import { useMutation } from '@tanstack/vue-query'
import type { LoginDTO, LoginResponse } from '@/types/auth/index'
import type { SuccessResponse } from '~/types/response'

const useLogin = () => {
  const { login } = useSuccessfulLogin()
  const { fetch } = useAPIFetch()

  return useMutation({
    mutationFn: (payload: LoginDTO) =>
      fetch<SuccessResponse<LoginResponse>>({
        method: 'POST',
        url: 'users/login',
        data: payload,
      }),
    onSuccess: async (data, { remember }) => {
      const { token, user } = data.data

      await login({
        token,
        remember,
        user,
      })
    },
  })
}

export default useLogin
